import { kea } from 'kea'
import { put } from 'redux-saga/effects'

import post from 'lib/utils/post'

import Bugsnag from '~/scenes/bugsnag'

import countryMenuForm from './form'

import menuLogic from '../logic'

export default kea({
  connect: {
    actions: [
      countryMenuForm,
      ['setValue', 'setValues'],
      menuLogic,
      ['openCountryModal', 'setCountries', 'loadCountries']
    ],
    props: [countryMenuForm, ['values'], menuLogic, ['selectedCountry', 'countryMenuOptions']]
  },

  takeLatest: ({ actions }) => ({
    [actions.setValue]: function * (action) {
      const { key, value } = action.payload

      if (key === 'country') {
        const { setValues } = this.actions
        const { countries, currencies } = yield this.get('countryMenuOptions')
        const newCurrency = countries.filter(c => c.value === value)[0].currency_code

        const isAllowedCurrency = currencies.indexOf(newCurrency) > -1
        if (isAllowedCurrency) {
          yield put(setValues({ currency: newCurrency }))
        }
      } else if (key === 'language') {
        const { loadCountries } = this.actions
        const { languages } = yield this.get('countryMenuOptions')
        const locale = languages.filter(l => l.value === value)[0].shortcode
        yield put(loadCountries(locale))
      }
    },

    [actions.loadCountries]: function * (action) {
      const { locale } = action.payload
      const { setCountries } = this.actions

      try {
        const response = yield post('/_countries', { locale })
        if (response.countries) {
          yield put(setCountries(response.countries))
        }
      } catch (error) {
        Bugsnag.notify(`get countries endpoint error at country Menu: ${error}`)
      }
    }
  })
})
